import { createSlice } from "@reduxjs/toolkit";

export const SURVEY_ANSWERS_SLICE_NAME = "surveyAnswers";

const surveyAnswersSlice = createSlice({
  name: SURVEY_ANSWERS_SLICE_NAME,
  initialState: {},
  reducers: {
    addSurveyAnswers(state, action) {
      return Object.assign({}, state, action.payload);
    },
    setSurveyAnswers(state, action) {
      return Object.assign({}, action.payload);
    },
  },
});

export const {
  addSurveyAnswers,
  setSurveyAnswers,
} = surveyAnswersSlice.actions;

export default surveyAnswersSlice.reducer;
